import { render, staticRenderFns } from "./ReturnOrderList.vue?vue&type=template&id=5e1bd5d2&scoped=true&"
import script from "./ReturnOrderList.vue?vue&type=script&lang=js&"
export * from "./ReturnOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1bd5d2",
  null
  
)

export default component.exports